const bannersApi = ({ apiClient }) => ({
  list(params) {
    return apiClient.get('banners', {}, params)
  },
  show(id) {
    return apiClient.get(`banners/${id}`, {}, {})
  },
  store(payload) {
    return apiClient.axios().post('banners', payload)
  },
  update(id, payload) {
    return apiClient.axios().post(`banners/${id}`, payload)
  },
  delete(id) {
    return apiClient.delete(`banners/${id}`)
  },
})

export default bannersApi
